<script setup>
import { useAppStateStore } from '@/js/core/stores/app-state-store';
import UserBarDropdown from './UserBarDropdown.vue';

const appStateStore = useAppStateStore();
</script>

<template>
  <div id="user-bar">
    <p>{{ appStateStore.userBarMessage }}</p>

    <UserBarDropdown />
  </div>
</template>
